import { CSS } from "../../../styles"

export const root = (): CSS => ({
  position: `relative`,
  zIndex: `100`,
})
